import axios from 'axios';

export const getAll = () => axios.get('/reuniao');
export const getProximas = (filter) => {
  const queryString = Object.keys(filter).map((key) => `${key}=${filter[key]}`).join('&');
  return axios.get(`/reuniao/proximas?${queryString}`);
};
export const getAnteriores = (filter) => {
  const queryString = Object.keys(filter).map((key) => `${key}=${filter[key]}`).join('&');
  return axios.get(`/reuniao/anteriores?${queryString}`);
};

export const vincularFormulario = (idReuniao, idFormulario) => axios.post(`/reuniao/formulario?idReuniao=${idReuniao}&idFormulario=${idFormulario}`)
export const verificarFormularioVinculado = (id) => axios.get(`/reuniao/${id}/formulario`,{ validateStatus: false })
export const cadastrar = (data) => axios.post('/reuniao', data);
export const atualizar = (data) => axios.put('/reuniao', data);
export const getById = (id) => axios.get(`/reuniao/${id}`);
export const getDocumentos = (id) => axios.get(`/reuniao/${id}/documentos`);
export const getDocumentosGerais = (id) => axios.get('/reuniao/documentos-gerais');
export const cadastrarDocumento = (data) => axios.post('/reuniao/documento', data);
export const removerDocumento = (idReuniao, idDocumento) => axios.delete(`/reuniao/documento?idReuniao=${idReuniao}&idDocumento=${idDocumento}`);
export const getAtaByIdReuniao = (idReuniao) => axios.get(`/reuniao/ata/${idReuniao}`);
export const cadastrarAta = (data) => axios.post('/reuniao/ata', data);
export const removerAta = (idAta) => axios.delete(`/reuniao/ata?idAta=${idAta}`);
export const getConvidados = (id) => axios.get(`/reuniao/${id}/convidados`);
export const cadastrarConvidado = (data) => axios.post('/reuniao/convidado', data);
export const removerConvidado = (idReuniao, idConvidado) => axios.delete(`/reuniao/convidado?idReuniao=${idReuniao}&idConvidado=${idConvidado}`);
export const getLugaresMesa = (id) => axios.get(`/reuniao/${id}/mesa`);
export const atualizarMesa = (data) => axios.put('/reuniao/atualizar-mesa', data);
export const excluirMesa = (id, idConvidado) => axios.delete(`/reuniao/excluir-mesa/${id}/convidado/${idConvidado}`);
export const convocacaoReuniao = (idReuniao) => axios.post(`/reuniao/convocacao?idReuniao=${idReuniao}`);

export const getPaginaDeConslheirosDisponíveis = (idReuniao, pagina, filter) => {
    const queryString = Object.keys(filter).map((key) => `${key}=${filter[key]}`).join('&');
    return axios.get(`reuniao/${idReuniao}/conselheiros?page=${pagina}&sort=usuario.nome&${queryString}`);
  };

// Midias de reunião
export const getFotosReuniao = (id) => axios.get(`/reuniao/${id}/fotos`);
export const postFotosReuniao = (data) => axios.post('/reuniao/foto', data);
export const getVideosReuniao = (id) => axios.get(`/reuniao/${id}/videos`);
export const postVideosReuniao = (data) => axios.post('/reuniao/video', data);
export const getAudiosReuniao = (id) => axios.get(`/reuniao/${id}/audios`);
export const postAudiosReuniao = (data) => axios.post('/reuniao/audio', data);
// Midias de reunião
